import Vue from 'vue'
import App from './app'
import router from '@router'
import store from '@state/store'
import '@components/_globals'
import globalMixin from './mixins/global'
import IdleVue from 'idle-vue'
import jsPDF from 'jspdf'
import '@utils/globals-init'
import broadCastJob from './state/modules/broadcast'
import polling from './state/modules/notifications'
import VueCryptojs from 'vue-cryptojs'

const eventsHub = new Vue()

Vue.use(broadCastJob, {
  enableBroadcast: process.env.VUE_APP_ENABLE_BROADCAST,
})
Vue.use(polling, {
  enablePolling: process.env.VUE_APP_ENABLE_NOTIFICATION_POLLING,
  pollingInterval: process.env.VUE_APP_ENABLE_NOTIFICATION_POLLING_INTERVAL,
  pollingIntervalLoanDetails:
    process.env.VUE_APP_ENABLE_NOTIFICATION_POLLING_INTERVAL_LOAN_DETAILS,
})
Vue.use(VueCryptojs)
Vue.use(jsPDF)
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: process.env.VUE_APP_IDLE_TIME - 1500,
})
Vue.mixin(globalMixin)

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

const app = new Vue({
  router,
  store,
  data() {
    return {
      messageStr: 'Hello',
    }
  },
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
